import styles from 'css/src/components/common/ColorPaletteTile.module.scss';

import React from 'react';
import classNames from 'classnames';

import ColorDots from 'js/src/components/common/ColorDots';
import Tooltip, { Placement } from 'js/src/components/common/ui/Tooltip';

type ColorPaletteTileProps = {
    name: string;
    hexColors: string[];
    selected: boolean;
    onClick: () => void;
    className?: string;
};

const ColorPaletteTile: React.FC<ColorPaletteTileProps> = ({
    name,
    hexColors,
    selected,
    onClick,
    className,
}) => {
    return (
        <Tooltip title={name} placement={Placement.TOP}>
            <div
                data-testid={`color-palette-tile-${name}`}
                className={classNames(
                    styles['tile'],
                    { [styles['selected']]: selected },
                    className,
                )}
                onClick={onClick}
            >
                <ColorDots colors={hexColors} size="md" max={hexColors.length} />
            </div>
        </Tooltip>
    );
};

export default ColorPaletteTile;
